import { Controller } from "@hotwired/stimulus"
import QRCode from "qrcode"

export default class extends Controller {
  static targets = ["modal", "canvas"]
  declare readonly modalTarget: HTMLElement
  declare readonly canvasTarget: HTMLCanvasElement

  async show() {
    const url = window.location.origin + window.location.pathname;
    await QRCode.toCanvas(this.canvasTarget, url, {
      width: 220,
      margin: 2,
      color: { dark: "#0f172a", light: "#ffffff" },
    });
    this.modalTarget.classList.add("visible");
  }

  close() {
    this.modalTarget.classList.remove("visible");
  }

  // Close when clicking the backdrop.
  backdropClick(event: MouseEvent) {
    if (event.target === this.modalTarget) this.close();
  }
}
